import { useState, lazy, Suspense } from "react";
import GameLauncher from "./gamelauncher";

// Dynamic imports for games using Vite's dynamic import
const gameComponents: {
  [key: string]: React.LazyExoticComponent<
    React.ComponentType<{ onClose: () => void }>
  >;
} = {
  snake: lazy(() => import("../games/snakegame")),
  tictactoe: lazy(() => import("../games/tictactoe")),
  tetris: lazy(() => import("../games/tetrisgame")),
};

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const GameManager = ({ isOpen, onClose }: Props) => {
  const [currentGame, setCurrentGame] = useState<string | null>(null);

  const handleGameLaunch = (gameId: string) => {
    setCurrentGame(gameId);
  };

  const handleGameClose = () => {
    setCurrentGame(null);
    onClose();
  };

  if (!isOpen) return null;

  // If a game is running, show that game
  if (currentGame && gameComponents[currentGame]) {
    const GameComponent = gameComponents[currentGame];
    return (
      <Suspense
        fallback={
          <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="text-white">Loading game...</div>
          </div>
        }
      >
        <GameComponent onClose={handleGameClose} />
      </Suspense>
    );
  }

  // Otherwise show the game launcher
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50">
      <GameLauncher onClose={onClose} onLaunchGame={handleGameLaunch} />
    </div>
  );
};

export default GameManager;
